import styled from "@emotion/styled";
import { Link } from "gatsby";
import * as React from "react";
import ArrowRight from "../svgs/arrow-right.svg";

const StyledArrowButton = styled(Link)`
  img {
    display: inline-block;
    height: 1.5rem;
    width: 1rem;
    margin-left: var(--macro);
    transition: all 0.6s cubic-bezier(0.76, 0, 0.24, 1);
  }

  &:hover,
  &:focus {
    img {
      filter: invert(100%);
    }
  }
`;

interface ArrowButtonProps {
  href: string;
  text: string;
  style?: React.CSSProperties;
  [key: string]: any;
}

export const ArrowButton = ({
  href,
  text,
  style,
  variant = "dark",
  className,
  ...props
}: ArrowButtonProps) => (
  <StyledArrowButton
    to={href}
    className={`btn-dark ${className}`}
    style={style}
    {...props}
  >
    {text}
    <img src={ArrowRight} alt="" aria-hidden={true} />
  </StyledArrowButton>
);
